export const environment = {
    production: false,
    apiUrl: 'https://devbmiapi.techprostudio.com',
    baseUrl: 'https://devbmiadmin.techprostudio.com',
    teacherUrl: 'https://devbmifaculty.techprostudio.com',
    studentUrl: 'https://devbmistudent.techprostudio.com',
  };


// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/environments/environment.ts